import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fea8c832&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fea8c832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea8c832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fea8c832')) {
      api.createRecord('fea8c832', component.options)
    } else {
      api.reload('fea8c832', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fea8c832&scoped=true&", function () {
      api.rerender('fea8c832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xim28Fmy9ep3/JS/comp/DocBox.vue"
export default component.exports